import { useMemo } from 'react'

import Carousel from '../../../../components/carousel'
import loader from '../../../../components/loader'
import dimensions from '../../../../utils/dimensions'
import PricingStore from '../stores/pricing-store'
import Features from './features'
import Plan from './plan'

const Plans = () => {
  const {
    loading,
    loadFailed,
    data = [],
    showMonthly,
  } = PricingStore.useContainer()

  const plans = useMemo(
    () =>
      data.filter(
        (sub) =>
          sub?.status === 'ACTIVE' &&
          sub?.frequency === (showMonthly ? 'MONTHLY' : 'ANNUAL'),
      ),
    [data, showMonthly],
  )

  return loader(
    loading,
    loadFailed,
    <div id='plans'>
      <Features />
      <Carousel
        data={plans}
        item={(planData, params) => <Plan data={planData} params={params} />}
        itemWidth={dimensions.vw(30) + dimensions.rem(1)}
      />
    </div>,
  )
}

export default Plans
